import * as React from "react";
import { Block } from "baseui/block";

import { toArray, arrayToggle } from "../utils/primitives";
import { CardOption } from "./CardOption";
import { ToggleOption } from "./ToggleOption";
import { RadioOption } from "./RadioOption";

const optionComponents = {
  select: CardOption,
  toggle: ToggleOption,
  radio: RadioOption,
};

type TCardSelectProps = {
  kind?: keyof typeof optionComponents;
  options?: unknown[];
  onChange?: (...args: unknown[]) => void;
  value?: unknown;
  [key: string]: TODO;
};

const CardSelect: React.FC<TCardSelectProps> = (props) => {
  const { options = [], onChange, value, kind = "select", ...restProps } = props;
  const OptionComponent = optionComponents[kind];

  function handleChange(toggleValue) {
    if (kind === "toggle") {
      onChange?.(arrayToggle(value, toggleValue));
    } else {
      onChange?.(toggleValue);
    }
  }

  return (
    <OptionGrid>
      {options.map((option) => (
        <OptionComponent
          key={option.value}
          onChange={handleChange}
          selected={isSelected(option.value, value)}
          {...option}
          {...restProps}
        />
      ))}
    </OptionGrid>
  );
};

const OptionGrid = (props) => (
  <Block
    display="grid"
    gridTemplateColumns={["1fr", "1fr", "repeat(auto-fit, 230px)"]}
    gridColumnGap={[null, null, "scale600", "scale800"]}
    gridRowGap={["scale600", "scale600", "scale600", "scale800"]}
    justifyContent="center"
    {...props}
  />
);

function isSelected(optionValue, selectedValues) {
  return (toArray(selectedValues) || []).includes(optionValue);
}

export { CardSelect };
